<template>
  <div class="text-center">
    <h5 class="mb-3">Paso 1: Escanea el código QR</h5>
    <p class="text-muted mb-4">
      Usa tu aplicación autenticadora para escanear este código QR:
    </p>

    <!-- QR Code -->
    <div class="qr-code-container">
      <div v-if="!qrCodeDataUrl && qrCodeUrl" class="text-center p-4">
        <div class="spinner-border text-primary mb-2" role="status">
          <span class="sr-only">Generando QR...</span>
        </div>
        <div class="small text-muted">Generando código QR...</div>
      </div>
      <img v-if="qrCodeDataUrl" :src="qrCodeDataUrl" alt="QR Code para 2FA" class="qr-code-image" />
    </div>

    <!-- Manual Entry -->
    <div class="mt-4">
      <p class="mb-2"><strong>O ingresa manualmente:</strong></p>
      <div class="secret-key-display" @click="$emit('copy-secret')">
        {{ secretKey }}
        <i class="ri-file-copy-line ml-2 text-primary"></i>
      </div>
      <div class="two-factor-help">
        <i class="ri-information-line help-icon"></i>
        Haz clic para copiar la clave secreta
      </div>
    </div>

    <!-- Backup Codes -->
    <div class="mt-4">
      <h6 class="mb-3">Códigos de recuperación:</h6>
      <p class="text-muted small mb-3">
        Guarda estos códigos en un lugar seguro. Puedes usarlos para acceder si pierdes tu dispositivo.
      </p>
      <ul class="recovery-codes">
        <li v-for="code in backupCodes" :key="code">{{ code }}</li>
      </ul>
      <button 
        @click="$emit('copy-codes')" 
        class="btn btn-outline-secondary btn-sm"
      >
        <i class="ri-file-copy-line mr-1"></i>
        Copiar códigos
      </button>
    </div>

    <!-- Actions -->
    <div class="mt-4 d-flex justify-content-between">
      <button 
        @click="$emit('cancel')" 
        class="btn btn-secondary"
        :disabled="loading"
      >
        <i class="ri-arrow-left-line mr-1"></i>
        {{ cancelLabel }}
      </button>
      <button 
        @click="$emit('continue')" 
        class="btn btn-primary"
        :disabled="loading"
      >
        Continuar
        <i class="ri-arrow-right-line ml-1"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoFactorQRStep',
  props: {
    qrCodeUrl: {
      type: String,
      required: true
    },
    qrCodeDataUrl: {
      type: String,
      default: ''
    },
    secretKey: {
      type: String,
      required: true
    },
    backupCodes: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    cancelLabel: {
      type: String,
      default: 'Volver al login'
    }
  },
  emits: ['copy-secret', 'copy-codes', 'cancel', 'continue']
};
</script> 